<div class="catalog-offers" #catalogOffers data-section-id="catalog-offers-section" data-section-name="Catalog Offers">
  <div class="catalog-offers__container">
    <div class="catalog-offers__header">
      <h2 class="catalog-offers__title">Revisa los catálogos con las mejores ofertas Unipay</h2>
     </div>

    <div class="catalog-offers__grid">
      @for (catalog of catalogs; track catalog.id) {
        <div class="catalog-offers__card-wrapper">
          <div class="catalog-offers__card"
               [style.background-color]="catalog.backgroundColor || '#ffffff'">
            <div class="catalog-offers__image-container" [style.background-color]="catalog.backgroundColor ">
              <img
                [src]="catalog.image || ''"
                [alt]="'Catálogo ' + catalog.title"
                class="catalog-offers__image"
                [style.width]="catalog.width"
              />
            </div>
          </div>
          <a
            href="{{ catalog.url }}"
            class="catalog-offers__link"
            (click)="onCatalogClick(catalog)"
          >
            Quiero ver las ofertas
          </a>
        </div>
      }
    </div>
  </div>
</div>
